/** Короткий формат даты `дд.мм.гг` (например `09.06.26`). Для невалидной
 *  строки возвращает «—». Вынесено из QuotesTable — переиспользуемый хелпер. */
export function formatShortDate(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  const dd = String(d.getDate()).padStart(2, '0')
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const yy = String(d.getFullYear() % 100).padStart(2, '0')
  return `${dd}.${mm}.${yy}`
}
